"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
const hooks_1 = require("hooks");
const portal_api_1 = require("portal-api");
const utils_1 = require("utils");
const utils_2 = require("../../../utils");
const EnrollmentForm_1 = __importDefault(require("../../forms/EnrollmentForm"));
const formatEnrollmentData_1 = require("../../forms/EnrollmentForm/func/formatEnrollmentData");
const Enrollments = ({ location, hasPermEnrollments, triggerGetData, }) => {
    // Hooks
    const { id } = (0, react_router_dom_1.useParams)();
    const locationHook = (0, react_router_dom_1.useLocation)();
    const query = (0, hooks_1.useQuery)();
    // Query
    const { data: users } = (0, portal_api_1.useGetInternalPortalV1UsersQuery)();
    const permissions = (0, utils_2.getPermissions)(users);
    // State
    const [hasProposedChanges, setHasProposedChanges] = (0, react_2.useState)(false);
    const [currentPath, setCurrentPath] = (0, react_2.useState)('');
    const [currentEnrollmentApp, setCurrentEnrollmentApp] = (0, react_2.useState)(null);
    const [skipEnrollments, setSkipEnrollments] = (0, react_2.useState)(true);
    const [enrollmentsData, setEnrollmentsData] = (0, react_2.useState)([]);
    const [enrollmentsArr, setEnrollmentsArr] = (0, react_2.useState)([]);
    // Query
    const { data: proposedChanges, isFetching: isLoadingProposedChanges } = (0, portal_api_1.useGetInternalPortalV1LocationsLocationIdProposedChangesQuery)({
        locationId: Number(id),
    });
    // Query
    const { data: enrollments, isFetching: isLoadingEnrollments, refetch: refetchEnrollments, } = (0, portal_api_1.useGetInternalPortalV1LocationsLocationIdEnrollmentsQuery)({
        locationId: Number(id),
    }, {
        skip: skipEnrollments,
    });
    const loadApplication = (0, react_2.useCallback)((id) => {
        const selectedRow = enrollmentsArr
            .filter((itm) => {
            return itm.id === id;
        })
            .at(0);
        if (selectedRow) {
            const { enrollmentApp, sameAddress, appStatus, sentToLenderAt } = (0, formatEnrollmentData_1.formatEnrollmentData)(selectedRow);
            setCurrentEnrollmentApp({
                ...enrollmentApp,
                sameAddress: sameAddress,
                status: appStatus,
                sentToLenderAt: sentToLenderAt,
            });
        }
    }, [enrollmentsArr]);
    const setupEnrollmentsData = (enrollments) => {
        const tmpEnrollmentsArr = enrollments;
        // Table Data
        const tmpEnrollmentsData = tmpEnrollmentsArr?.map((itm) => {
            const tmpEnrollment = {
                ...itm,
                id: itm.id,
                merchantApplication: {
                    ...itm.merchantApplication,
                    createdAt: (0, utils_1.formatISODateStringAsUSMonthDayYear)(itm.merchantApplication.createdAt),
                },
                storeNum: location?.adsStoreNumber,
            };
            return tmpEnrollment;
        });
        storeEnrollmentDataInState(tmpEnrollmentsArr, tmpEnrollmentsData);
    };
    const storeEnrollmentDataInState = (tmpEnrollmentsArr, tmpEnrollmentsData) => {
        setEnrollmentsArr(tmpEnrollmentsArr);
        setEnrollmentsData(tmpEnrollmentsData);
    };
    (0, react_2.useEffect)(() => {
        if (enrollments && !isLoadingEnrollments) {
            setupEnrollmentsData(enrollments);
        }
    }, [enrollments, isLoadingEnrollments]);
    (0, react_2.useEffect)(() => {
        if (hasPermEnrollments &&
            enrollmentsData?.length > 0 &&
            currentEnrollmentApp === null) {
            // URL Query Param
            const paramAppId = query.get('app_id');
            let enrollmentListSelectedId;
            if (paramAppId) {
                enrollmentListSelectedId = enrollmentsData
                    .filter((itm) => {
                    return String(itm.merchantApplication.id) === paramAppId;
                })
                    .at(0)?.id;
            }
            // When you arrive on the page use the last item in the list
            // Otherwise if there is a url query param, use that instead
            const firstAppId = enrollmentsData[0]?.id;
            const appIdToLoad = enrollmentListSelectedId ?? firstAppId;
            // Load App By Id
            loadApplication(appIdToLoad);
        }
    }, [
        enrollmentsData,
        hasPermEnrollments,
        currentEnrollmentApp,
        enrollmentsArr,
    ]);
    (0, react_2.useEffect)(() => {
        if (enrollmentsData?.length === 0) {
            setCurrentEnrollmentApp(null);
        }
    }, [enrollmentsData]);
    (0, react_2.useEffect)(() => {
        if (hasPermEnrollments && triggerGetData) {
            setSkipEnrollments(false);
        }
    }, [hasPermEnrollments, triggerGetData]);
    (0, react_2.useEffect)(() => {
        if (locationHook.pathname !== currentPath &&
            currentEnrollmentApp !== null) {
            setCurrentEnrollmentApp(null);
            setEnrollmentsArr([]);
            setCurrentPath(locationHook.pathname);
            refetchEnrollments();
        }
    }, [locationHook]);
    (0, react_2.useEffect)(() => {
        const tmpChanges = proposedChanges;
        if (tmpChanges && tmpChanges.length > 0) {
            setHasProposedChanges(true);
        }
    }, [proposedChanges]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: permissions.hasLocationEnrollmentRead() && currentEnrollmentApp ? ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(EnrollmentForm_1.default, { initVals: currentEnrollmentApp, unsetVals: setCurrentEnrollmentApp, locationId: location?.locationId, hasProposedChanges: hasProposedChanges, hasUpdatePermission: permissions.hasLocationEnrollmentUpdate() }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: permissions.hasLocationEnrollmentRead() && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { children: isLoadingEnrollments || isLoadingProposedChanges ? ((0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center", children: (0, jsx_runtime_1.jsx)(react_1.CSpinner, { color: "primary" }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: enrollmentsData?.length > 0
                            ? 'Please select an enrollment.'
                            : 'No enrollments found.' })) }) })) })) }));
};
exports.default = Enrollments;
